import React from 'react';
import { registerWidget } from '@okapi/core';
import { BannersCarouselWidget, BannersCarouselWidgetData } from 'entries/common/widgets';
import { BannersResponse, SharedBannersResponse } from 'api/placements-api';
import { BannerEvent } from 'features/banners-carousel/types';
import { analyticsUtils } from 'utils/analytics-utils';
import { fetchApiClient } from 'api/fetch-api-client/fetch-api-client';
import { impressionClickTracking, impressionViewTracking } from 'api/fetch-api-client/tracking';
import { EnvState } from 'api/fetch-api-client/types';

registerWidget<(SharedBannersResponse | BannersResponse) & EnvState, BannersCarouselWidgetData>(
  `${__NAME__}/banners-carousel`,
  serverData => {
    return data => {
      const { adaptiveMode, autoplay, gaName, gaPosition, loop, slidesPerView, targetBlank } = data;

      const contentIdClicked: string[] = [];
      const contentIdViewed: string[] = [];

      const { env } = serverData;

      if (env) {
        fetchApiClient.setHost(env.host);
        fetchApiClient.addDefaultHeader('x-api-key', env.apiKey);
      }

      const getEventParams = (position: number) => ({
        elementType: 'banner',
        elementBlock: gaPosition,
        promotions: [
          {
            name: gaName,
            creative: 'monetization',
            position,
          },
        ],
      });

      const onImpressionContentClick = (e: BannerEvent) => {
        if (!contentIdClicked.includes(e.contentId)) {
          impressionClickTracking(e.contentId);
          analyticsUtils.sendEvent('GA:promoClick', getEventParams(e.bannerPosition));
        }

        contentIdClicked.push(e.contentId);
      };

      const onImpressionContentView = (e: BannerEvent) => {
        if (!contentIdViewed.includes(e.contentId)) {
          impressionViewTracking(e.contentId);
          analyticsUtils.sendEvent('GA:promoView', getEventParams(e.bannerPosition));
        }

        contentIdViewed.push(e.contentId);
      };

      return (
        <BannersCarouselWidget
          adaptiveImpression={serverData}
          {...{
            adaptiveMode,
            autoplay,
            loop,
            slidesPerView,
            targetBlank,
            onImpressionContentClick,
            onImpressionContentView,
          }}
        />
      );
    };
  }
);
